import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import FetchService from '../../services/fetchService';
import urlService from '../../services/urlService';
import validateValue from '../../utils/validateValue';
import BookerContext from '../../context/bookerContext';
import BookerShortContext from '../../context/bookerShortContext';
import fieldParams from '../../const/fieldParams';
import EmailInput from '../InputControls/EmailInput';
import SupportEmail from './SupportEmail';
import { mixpanelEventTrack } from '../../services/mixpanel';
import getBillData from '../../utils/getBillData';
import ReceiptList from './ReceiptList';
import '../../assets/styles/receipt.sass';

const Receipt = () => {
  const context = useContext(BookerContext);
  const { state: { rideId, isWebBooker, accountCreation: { done = false, emailAdded = false } = {} } = {} } = context;
  const { loading, setLoading, togglePopup } = useContext(BookerShortContext);

  const fieldKey = 'eReceipt';
  const { value: email } = useSelector(({ email }) => email || {});
  const { titleSub, pattern } = fieldParams[fieldKey];
  const [isEmailValid, setIsEmailValid] = useState(email ? validateValue(email, pattern) : true);

  const [bill, setBill] = useState({});

  useEffect(() => {
    setIsEmailValid(email ? validateValue(email, pattern) : true);
  }, [email]);

  useEffect(() => {
    getBillData({ rideId, setLoading, setBill });
  }, [rideId, setLoading]);

  const handleSendReceipt = () => {
    if (!rideId || !email) return;

    return FetchService.getWebApiResource(urlService.sendEReceipt(rideId, email))
      .then(response => {
        setLoading(false);
        mixpanelEventTrack(isWebBooker ? 'receiptSentWebBook' : 'receiptSent');
        togglePopup(true, 'eReceipt');
      })
      .catch(error => {
        setLoading(false);
        togglePopup(true, 'eReceiptError');
      });
  };

  return (
    <div className="receipt-container">
      <div className="receipt-title">Thank you for choosing Curb!</div>

      {!loading && Object.keys(bill).length && (
        <>
          <div className="total-container">
            <div className="total-label">Your Total:</div>
            <div className="total-value">${Number(bill.total / 100).toFixed(2)}</div>
          </div>
          <ReceiptList bill={bill} />
        </>
      )}

      {!isWebBooker && !done && !emailAdded && (
        <div className="email-receipt-container">
          <div className="email-receipt-header">{titleSub}</div>
          <div className="email-send-container">
            <EmailInput fieldKey={fieldKey} />
            <p className={`email-send-link ${isEmailValid && email ? '' : 'disabled'}`} onClick={handleSendReceipt}>
              Send Receipt
            </p>
          </div>
        </div>
      )}

      <SupportEmail />
      <div className="buttons-container">
        {/*<a className="download-receipt text-center" href="">*/}
        {/*  Download Receipt*/}
        {/*</a>*/}
      </div>
    </div>
  );
};

export default Receipt;
